"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadCardStyles = void 0;
const merge = require("deepmerge"),
  DownloadCardStyles = (theme, variant) => {
    return {
      background: "#FFFFFF",
      border: "0.1rem solid rgba(0, 0, 0, 0.15)",
      boxShadow: "unset",
      display: "block",
      fontSize: "1.6rem",
      padding: "3.5rem 4rem",
      ".download-card__title": {
        fontFamily: theme.fontFamilies.bold,
        fontSize: "2.1rem",
        marginBottom: "1rem",
        marginTop: "0"
      },
      ".download-card__description": {
        fontFamily: "inherit",
        fontSize: "inherit",
        margin: "0"
      },
      ".download-card__list": {
        display: "block",
        marginTop: "2rem",
        padding: "0"
      },
      ".download-card__list-item": {
        borderBottom: "0.2rem solid #F4F5F8",
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "row"
        },
        alignItems: {
          xs: "flex-start",
          sm: "center"
        },
        justifyContent: "space-between",
        padding: "1rem 0"
      },
      ".download-card__content": {
        display: "block",
        fontFamily: theme.fontFamilies.default,
        fontSize: "1.6rem",
        lineHeight: "1.4"
      },
      ".download-card__link": {
        borderRadius: "0",
        display: "inline-block",
        fontFamily: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        margin: "0 0.5em 0 0",
        padding: "0",
        textAlign: "left",
        textDecoration: "underline",
        textTransform: "unset",
        "&:hover,&:active": {
          textDecoration: "none"
        },
        "&:focus-visible": merge(theme.mixins.focus, {
          textDecoration: "none"
        })
      },
      ".download-card__content-caption": {
        display: "inline-block",
        fontFamily: variant === "press-release" ? theme.fontFamilies.default : theme.fontFamilies.italic,
        fontSize: "1.4rem",
        lineHeight: "1.2"
      },
      ".download-card__actions": {
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end",
        margin: {
          xs: "2rem 0 0",
          sm: "0 0 0 2rem"
        }
      },
      ".download-card__image-type": {
        width: "auto"
      },
      ".download-card__copy-button": {
        backgroundColor: "#F4F5F8",
        borderColor: "#EAEAEB",
        borderRadius: "0.2rem",
        boxShadow: "unset",
        color: "#000000",
        fontSize: "1rem",
        height: "2.3rem",
        margin: "0 0 0 1.5rem",
        padding: "0 1rem",
        textTransform: "unset",
        "&:hover,&:active": {
          backgroundColor: "#EAEAEB",
          borderColor: "#EAEAEB",
          color: "#000000"
        },
        "&:focus-visible": merge(theme.mixins.focus, {
          backgroundColor: "#EAEAEB",
          borderColor: "#EAEAEB",
          color: "#000000"
        })
      }
    };
  };
exports.DownloadCardStyles = DownloadCardStyles;